import { Checkbox, FormControlLabel } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';

const SexFilter = ({ sex }) => {

    const { t, i18n } = useTranslation(['translation']);

    const [checked, setChecked] = useState([true, true]);

    const handleChange1 = (event) => {
        if(event.target.checked || checked[1]) {
            setChecked([event.target.checked, checked[1]]);
            sex([event.target.checked, checked[1]])
        }
    };

    const handleChange2 = (event) => {
        if(event.target.checked || checked[0]) {
            setChecked([checked[0], event.target.checked]);
            sex([checked[0], event.target.checked])
        }
    };

    const children = (
        <Box sx={{ display: 'flex', flexDirection: 'row', ml: 6 }}>
            <FormControlLabel
                label={t('Woman')}
                control={<Checkbox checked={checked[0]} style ={{ color: "black"}} onChange={handleChange1} />}
            />
            <FormControlLabel
                label={t('Man')}
                control={<Checkbox checked={checked[1]} style ={{ color: "black"}} onChange={handleChange2} />}
            />
        </Box>
    );

    return (
        <div className='visidea-visualsearch__filter-sex'>
            {children}
        </div>
    )
}

export default SexFilter